import { TarefasAConcluir, TarefasConcluidas } from "./ConclusaoTarefas";
import { Actions } from "./Actions";
import { Provider } from "../../Context";
import { ResumoOrcamentos } from "./ResumoOrcamentos";

export function AppDashboard(){
    const tarefasAConcluir = Actions({endpoint:"tarefasaconcluir"});   
    const tarefasConcluidas = Actions({endpoint:"tarefasconcluidas"});
    const resumoOrcamentos = Actions({endpoint:"resumoorcamentos"});


    return(
        
        <div className="container">
            <ul class="collapsible">
                <li class="active">
                    <div class="collapsible-header"><i class="material-icons">task</i>Resumo das tarefas</div>
                    <div class="collapsible-body">
                        <div className="row">
                            <div className="col s6">
                                <div className="col s12 center-col red-information"><h5>A concluir</h5></div>
                                    <Provider value={tarefasAConcluir}>
                                        <TarefasAConcluir></TarefasAConcluir>                    
                                    </Provider>
                            </div>
                            <div className="col s6">
                                <div className="col s12 center-col green-information"><h5>Concluída(s)</h5></div>
                                <Provider value={tarefasConcluidas}>
                                    <TarefasConcluidas></TarefasConcluidas>
                                </Provider>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="active">
                    <div class="collapsible-header"><i class="material-icons">folder</i>Resumo dos orçamentos</div>
                    <div class="collapsible-body">
                        <div className="row">
                            <Provider value={resumoOrcamentos}>
                                <ResumoOrcamentos></ResumoOrcamentos>
                            </Provider>
                        </div>
                    </div>
                </li>

            </ul>
        </div>
    );
}